export default "__VITE_ASSET__Bqphox51__"